import React from "react";
import { useNavigate } from "react-router-dom";

const ChildAddedPopup = ({
  childName,
  age,
  setShowAddChildPopup,
  translationMap,
  selectedImage,
  gender
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="modal fade Custom_Modal_Box show"
      id="childdetailsmodal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{ display: "block" }}>
      
      <div className="modal-dialog  CoveragePlan_Dialog2" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="Title_Inner_Box">
              <h6 className="MainTitleOne">
                {translationMap?.childDetails ?? "Child Details"}
              </h6>
            </div>
          </div>
          <div className="modal-body">
            <div className="baraem_modal_body">
              <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                <button type="button" className="close" data-dismiss="alert">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    
                    <path
                      d="M17 7L7 17M7 7L17 17"
                      stroke="#002F70"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                    </path>
                  </svg>
                </button>
                <div className="Icon_box">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                  <a href="javascript:void(0);">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                  </a>
                </div>
                <div className="alert_text">
                  <h6>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                    <a href="javascript:void(0);">
                      {translationMap?.childAdded ?? "Child added"}
                    </a>
                  </h6>
                  <p className="number_txt">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                    <a href="javascript:void(0);">
                      {translationMap?.childAddedSuccessfully ??
                      "A new child has been successfully added to the list."}
                    </a>
                  </p>
                </div>
              </div>
              <div className="baraem_white_contact_box baraem_white_contact_box_maxwidth">
                <div className="info_box">
                  <span className="icon_box">
                    {selectedImage ?
                    <img
                      className="image"
                      src={selectedImage}
                      alt={selectedImage ? "Selected image" : "Displaying child logo"} /> :


                    <svg
                      width="24"
                      height="26"
                      viewBox="0 0 24 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      
                        <path
                        d="M22.9168 25C22.9168 23.1392 22.9168 22.2089 22.6872 21.4518C22.1701 19.7473 20.8362 18.4134 19.1317 17.8963C18.3746 17.6667 17.4442 17.6667 15.5835 17.6667H8.91683C7.05608 17.6667 6.1257 17.6667 5.36864 17.8963C3.6641 18.4134 2.33022 19.7473 1.81315 21.4518C1.5835 22.2089 1.5835 23.1392 1.5835 25M18.2502 7C18.2502 10.3137 15.5639 13 12.2502 13C8.93645 13 6.25016 10.3137 6.25016 7C6.25016 3.68629 8.93645 1 12.2502 1C15.5639 1 18.2502 3.68629 18.2502 7Z"
                        stroke="#002F70"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      
                      </svg>
                    }
                  </span>
                  <h6 className="MainTitleOne">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                    <a href="javascript:void(0);">{childName}</a>
                  </h6>
                </div>
                <div className="age_info">
                  <p>
                    <b>
                      {translationMap?.age ?? "Age: "}
                      {": "}
                    </b>
                    {age}{" "}
                    {age > 1 ?
                    translationMap?.months ?? "months" :
                    translationMap?.month ?? "month"}
                  </p>
                </div>
                <div className="age_info">
                  <p>
                    <b>
                      {translationMap?.gender ?? "Gender"}
                      {": "}
                    </b>
                    {gender === "M" ?
                    translationMap?.male :
                    translationMap?.female}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer modal_footer_btn_box2">
            <button
              type="button"
              className="btn bluetrans_btn_link"
              data-dismiss="modal"
              onClick={() => {
                setShowAddChildPopup(false);
                navigate("/");
              }}>
              
              {translationMap?.close ?? "Close"}
            </button>
          </div>
        </div>
      </div>
    </div>);

};

export default ChildAddedPopup;